import React, { useState, useEffect, useContext } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import moment from "moment";
import { Button } from "@material-ui/core";
import Header from "../../Home/Header/Header";
import { StoreContext } from "../../../../Store/Provider";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Drawer from "@material-ui/core/Drawer";
import Sidebar from "../../Home/Sidebar/Sidebar";
import Line from "../../../SVG/Line";
import "./scheduleSearchResult.css";
import PlaceDot from "../../../SVG/PlaceDot";
import { routeConstant } from "../../../../Route/utils/routeConstant";
import { ProjectName } from "../../../../Config";
import { useNavigate } from "react-router-dom";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function ScheduleSearchResult(props) {
  const classes = useStyles();
  const context = useContext(StoreContext);
  const [comLogo, setComLogo] = useState([]);
  const [compName, setCompName] = useState([]);
  const [lines, setLines] = useState([]);
  const [open, setOpen] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [totalCards, setTotalCards] = useState(0);
  const history = useNavigate();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    if (context.transportmodeglobal === "SEA") {
      createDataSetSea();
    } else if (context.transportmodeglobal === "AIR") {
      createDataSetAir();
    }
  }, []);

  const createDataSetAir = () => {
    let data = [];
    context.searchResult.forEach((element) => {
      data.push(element);
    });
    setLines(data);
    setTotalCards(context.searchResult.length);
  };

  const createDataSetSea = () => {
    let logo = [];
    let data = [];
    let companyName = [];
    context.searchResult.forEach((element) => {
      logo.push(element.line_logo);
      companyName.push(element.line_name);
      let tempData = [];
      element.line.forEach((item) => {
        tempData.push(item);
      });
      data.push(tempData);
    });
    setComLogo(logo);
    setCompName(companyName);
    setLines(data);
    setTotalCards(context.searchResult.length);
  };

  const requestQuote = (data, index) => {
    history("/Home/RequestQuote/RequestResult/RequestQuoteForm");
    if (context.transportmodeglobal === "SEA") {
      context.setDataQuote({
        logo: comLogo[index],
        compName: compName[index],
        data,
      });
    } else if (context.transportmodeglobal === "AIR") {
      context.setDataQuote({
        logo: "",
        compName: "",
        data,
      });
    }
  };

  console.log("A", context.dataQuote.data);

  return (
    <div className="home">
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert severity="error" onClose={handleClose}>
          {alertText}
        </Alert>
      </Snackbar>
      <Header />
      {totalCards === 0 && context.requestQuote.OriginPort === "" ? (
        <button
          className="hide"
          onClick={() => history(routeConstant.Schedule)}
        >
          Previous
        </button>
      ) : (
        ""
      )}
      <div className="shipmentsListingHome">
        <Drawer
          variant="persistent"
          className={clsx(classes.drawerLeft, {
            [classes.drawerOpen]: context.menuBar,
            [classes.drawerClose]: !context.menuBar,
          })}
          classes={{
            paper: clsx(classes.drawerPaperleft, {
              [classes.drawerOpen]: context.menuBar,
              [classes.drawerClose]: !context.menuBar,
            }),
          }}
        >
          <Sidebar />
        </Drawer>
        <main className={clsx(classes.content)}>
          <div className="scheduleSearchResultScreen container">
            <div className="scheduleSearchResultScreenHeadingDiv my-2">
              <h6
                className="scheduleSearchResultScreenHeading pointer"
                onClick={() => {
                  history(routeConstant.Schedule);
                }}
              >
                <ArrowBackIosIcon /> Go Back Search
              </h6>
              {context.requestQuote.OriginPort ? (
                <span>{totalCards} RESULTS FOUND</span>
              ) : (
                ""
              )}
            </div>
            <div className="scheduleSearchResultScreenSubHeadingDiv my-2">
              <div className="scheduleSearchResultScreenSubHeadingDivLeft">
                <img
                  src={`/${ProjectName}/Assets/Images/SailingScheduleResult.svg`}
                  alt="SailingScheduleResult"
                />
                <div>
                  <span>Sailing schedule</span>
                  <p>
                    Start scheduling your shipment and <br /> send your cargo
                    anywhere in the world.
                  </p>
                </div>
              </div>
              {totalCards ? (
                <div className="scheduleSearchResultScreenSubHeadingDivRight shipmentDetailsDiv ">
                  <div className="shpDetailsRouteDiv">
                    <div className="shptimelinebody">
                      <span title={context.requestQuote.OriginPort}>
                        {context.requestQuote.OriginPort}
                      </span>
                      <div className="shptimelinecontainer">
                        <span>
                          <PlaceDot
                            colorCode={"rgba(var(--text-heading-light))"}
                          />
                        </span>
                        <span>
                          <PlaceDot
                            colorCode={"rgba(var(--text-heading-light))"}
                          />
                        </span>
                        <Line
                          colorCode={"rgba(var(--text-heading-light))"}
                          classDotted={"dottedline"}
                        />
                      </div>
                      <span title={context.requestQuote.destinationPort}>
                        {context.requestQuote.destinationPort}
                      </span>
                    </div>
                    <p className="etdEtap">
                      <span title={context.requestQuote.OriginPortFullName}>
                        {context.requestQuote.OriginPortFullName}
                      </span>
                      <span
                        title={context.requestQuote.destinationPortFullName}
                      >
                        {context.requestQuote.destinationPortFullName}
                      </span>
                    </p>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="scheduleSearchResultBodyInner">
              {context.searchResult.length === 0 ? (
                <div className="scheduleCardsZero">No Schedule found.</div>
              ) : context.transportmodeglobal === "SEA" ? (
                lines.map((element, index) => {
                  return element.map((item, i) => {
                    let date = new Date(0);
                    date.setUTCSeconds(item.cutOff);
                    const cutoffdate = moment(date).format("DD/MM/YYYY");
                    return (
                      <div key={i} className="scheduleSearchcardbody">
                        <div className="scheduleSearchcardbodyCommon mb-2 pb-2">
                          <div className="scheduleSearchcardbodyInner">
                            <div className="scheduleSearchcardInner compdetails ps-0">
                              <img src={comLogo[index]} alt="company logo" />
                              <span>{compName[index]}</span>
                            </div>
                            <div className="scheduleSearchcardInner commondetails">
                              <span>TRANSIT DAYS</span>
                              <p>{item.transitTime} Days</p>
                            </div>
                            <div className="scheduleSearchcardInner commondetails">
                              <span>ETA</span>
                              <p>{cutoffdate}</p>
                            </div>
                            <div className="scheduleSearchcardInner requestQuote">
                              <Button
                                variant="contained"
                                onClick={() => {
                                  requestQuote(item, index);
                                }}
                              >
                                Request Quote
                              </Button>
                            </div>
                          </div>
                        </div>
                        <div className="scheduleSearchcardbodyItterarte">
                          {item.transShipments.map((transShipments, index) => {
                            let etdDate = new Date(0);
                            etdDate.setUTCSeconds(
                              transShipments.departure.date
                            );
                            const etd = moment(etdDate).format("DD/MM/YYYY");
                            let etaDate = new Date(0);
                            etaDate.setUTCSeconds(transShipments.arrival.date);
                            const eta = moment(etaDate).format("DD/MM/YYYY");
                            return (
                              <div
                                key={index}
                                className="scheduleSearchcardbodyInner"
                              >
                                <div className="scheduleSearchcardInner commondetails ps-0">
                                  <span>Vessel</span>
                                  <p title={transShipments.vesselName}>
                                    {!transShipments.vesselName &&
                                    transShipments.vesselName === null
                                      ? "N/A"
                                      : transShipments.vesselName}
                                  </p>
                                </div>
                                <div className="scheduleSearchcardInner commondetails">
                                  <span>Service</span>
                                  <p title={transShipments.service}>
                                    {!transShipments.service &&
                                    transShipments.service === null
                                      ? "N/A"
                                      : transShipments.service}
                                  </p>
                                </div>
                                <div className="scheduleSearchcardInner commondetails">
                                  <span>ETD</span>
                                  <p>{!etd && etd !== null ? "N/A" : etd}</p>
                                </div>
                                <div className="scheduleSearchcardInner commondetails">
                                  <span>ETA</span>
                                  <p>{!eta && eta !== null ? "N/A" : eta}</p>
                                </div>
                                <div className="scheduleSearchcardInner milecol">
                                  <div className="searchshptimelineBody">
                                    <span>ORIGIN</span>
                                    <div className="searchshptimelinecontainer">
                                      <span>
                                        <PlaceDot
                                          colorCode={
                                            "rgba(var(--text-heading-light))"
                                          }
                                        />
                                      </span>
                                      <span>
                                        <PlaceDot
                                          colorCode={
                                            "rgba(var(--text-heading-light))"
                                          }
                                        />
                                      </span>
                                      <Line
                                        colorCode={
                                          "rgba(var(--text-heading-light))"
                                        }
                                        classDotted={"dottedline"}
                                      />
                                    </div>
                                    <span>DESTINATION</span>
                                  </div>
                                  <p>
                                    <span
                                      title={transShipments.departure.portName}
                                    >
                                      {transShipments.departure.portName}
                                    </span>
                                    <span
                                      title={transShipments.arrival.portName}
                                    >
                                      {transShipments.arrival.portName}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  });
                })
              ) : (
                lines.map((item, i) => {
                  return (
                    <div key={i} className="scheduleSearchcardbody">
                      <div className="scheduleSearchcardbodyItterarte">
                        <div className="scheduleSearchcardbodyInner">
                          <div className="scheduleSearchcardInner commondetails ps-0">
                            <span>Flight</span>
                            <p title={item.ident_iata}>
                              {!item.ident_iata && item.ident_iata === null
                                ? "N/A"
                                : item.ident_iata}
                            </p>
                          </div>
                          <div className="scheduleSearchcardInner commondetails">
                            <span>Aircraft Type</span>
                            <p title={item.aircraft_type}>
                              {!item.aircraft_type &&
                              item.aircraft_type === null
                                ? "N/A"
                                : item.aircraft_type}
                            </p>
                          </div>
                          <div className="scheduleSearchcardInner commondetails">
                            <span>ETD</span>
                            <p>
                              {!item.scheduled_in && item.scheduled_in !== null
                                ? "N/A"
                                : moment(item.scheduled_in).format(
                                    "DD/MM/YYYY"
                                  )}
                            </p>
                          </div>
                          <div className="scheduleSearchcardInner commondetails">
                            <span>ETA</span>
                            <p>
                              {!item.scheduled_out &&
                              item.scheduled_out !== null
                                ? "N/A"
                                : moment(item.scheduled_out).format(
                                    "DD/MM/YYYY"
                                  )}
                            </p>
                          </div>
                          <div className="scheduleSearchcardInner milecol">
                            <div className="searchshptimelineBody">
                              <span>ORIGIN</span>
                              <div className="searchshptimelinecontainer">
                                <span>
                                  <PlaceDot
                                    colorCode={
                                      "rgba(var(--text-heading-light))"
                                    }
                                  />
                                </span>
                                <span>
                                  <PlaceDot
                                    colorCode={
                                      "rgba(var(--text-heading-light))"
                                    }
                                  />
                                </span>
                                <Line
                                  colorCode={"rgba(var(--text-heading-light))"}
                                  classDotted={"dottedline"}
                                />
                              </div>
                              <span>DESTINATION</span>
                            </div>
                            <p>
                              <span title={item.origin_iata}>
                                {item.origin_iata}
                              </span>
                              <span title={item.destination_iata}>
                                {item.destination_iata}
                              </span>
                            </p>
                          </div>
                          <div
                            className="scheduleSearchcardInner requestQuote"
                            style={{
                              width: "17%",
                            }}
                          >
                            <Button
                              variant="contained"
                              onClick={() => {
                                requestQuote(item, i);
                              }}
                            >
                              Request Quote
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawerLeft: {
    width: "18%",
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerPaperleft: {
    top: "auto",
    height: "calc(100% - 3rem)",
    visibility: "visible !important",
    transform: "translateX(0px) !important",
  },
  drawerOpen: {
    width: "18%",
    minWidth: "16rem",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: "2.5rem",
  },
}));

export default ScheduleSearchResult;
